module.exports = __webpack_public_path__ + "img/contacts__inst.e842dcd7.svg";